import { useState } from "react";
import { useParamsContext } from "../../provider/ParamsProvider";
import { useEffectAsync } from "./useEffectAsync"

export function listEffect(listContext, loader, dependencies = []) {
  const { flush_params } = useParamsContext();
  useEffectAsync(async () => {
    listContext.setLoading(true)
    // listContext.setData([])
    let res = await loader(listContext)
    // console.log(res)
    let { data, total_pages, cnt, is_error, error, totals } = res;
    listContext.setLoading(false)
    if (is_error) {
      listContext.setError(error?.message || 'Unknown error')
      return;
    }
    listContext.setData(data)
    listContext.setTotals(totals)
    listContext.setTotalPages(total_pages)
    listContext.setCnt(cnt)
    listContext.setError('')
  }, [flush_params, listContext.sort, listContext.order, listContext.page, JSON.stringify(listContext.filter), listContext.limit, ...dependencies])
}
